let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2zLwu")).then(() => parcelRequire('3kY9c'));